/**
 * <s-share-button> — Share Button Web Component
 * Opens the native share sheet when available; otherwise copies the link
 * and shows a toast. Reads its data from attributes written by Liquid:
 *   share-url, share-title, copied-message
 */
class SShareButton extends HTMLElement {
  #ac;

  connectedCallback() {
    const button = this.querySelector('button');
    if (!button) return;
    this.#ac = new AbortController();
    button.addEventListener('click', (event) => this.#share(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #share(event) {
    event.preventDefault();
    event.stopPropagation();
    const url = this.getAttribute('share-url') || window.location.href;
    const title = this.getAttribute('share-title') || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      document.dispatchEvent(new CustomEvent('s-notification:add', {
        detail: { message: this.getAttribute('copied-message') || '', variant: 'success' },
      }));
    } catch {
      window.prompt('', url);
    }
  }
}

if (!customElements.get('s-share-button')) {
  customElements.define('s-share-button', SShareButton);
}
